module.exports = __webpack_public_path__ + "static/media/3.4e323f55.jpg";